
  import { Component, Vue, Watch, Prop } from "vue-property-decorator";
  
  @Component
  export default class PackageComparing extends Vue
  {
  
    /**
       * 是否显示
       * @private
       * @returns string
       */
       @Prop({type: Boolean, default: false})
      private value: boolean;
  
      /**
       * 套餐列表
       * @private
       * @returns string
       */
       @Prop({type: Array})
      private healthProductsList: any;


      /**
       * 套餐详情id
       * @private
       * @returns number
       */
       @Prop({})
      private id: any;

      /**
       * 是否显示对比弹框 
       * @private
       * @returns boolean
       */
       private get showPopup(): boolean
      {
          return this.value;
      }
   
  
       /**
       * 返回弹框状态 
       * @private
       */
      private set showPopup(value: boolean)
      {
          this.$emit("input", value);
      }
  
      /**
       * 关闭弹窗
       * @private
       */
       private closePopup() {
          this.$emit("close")
      }
  
      /**
       * 套餐详情
       * @private
       */
      private onPackageDetail(id: string) {
        this.$router.push({name: 'rights-package-detail', query: {packageId: id, isRightsIdToBuy: this.id + ""}});
      }

      /**
        * 权益详情
        * @private
        * @returns void
        */
        private onRightsDetail () {
            this.$router.push({name: 'rights-order-submit', query: {id: this.id + ""}})
        }
  
    
  }
  